// TODO: Combine with postMessage service for a duplex connection
type TFunc = (...data: any[]) => void;

const events = new Map<string, TFunc>();

export const receiveBroadcast = (id: string, data: any) => {
  if (!events.has(id)) {
    return console.error(`Event with id ${id} has no subscription`);
  }

  return events.get(id)?.(data);
};

export const subscribeToEvent = (id: string, fn: TFunc) => {
  events.set(id, fn);
};
